import Button from "hardcover-ui/components/Button";
import Icon from "hardcover-ui/components/Icon";
import Text from "hardcover-ui/components/Text";
import useCurrentUser from "hooks/fragments/useCurrentUser";
import idIcon from "icons/duotone/id-card.svg";
import librarianRolesForUser from "lib/policies/librarianRolesForUser";

export default function ApplyLibrarianButton() {
  const user = useCurrentUser();
  const librarianRoles = user ? librarianRolesForUser(user) : [];

  // If already a librarian, don't show this button
  if (user?.pro || librarianRoles?.indexOf("librarian") !== -1) {
    return false;
  }

  return (
    <div className="flex gap-2 items-center flex-wrap justify-end">
      <Text variant="secondary" className="hidden lg:inline-block">
        Want to edit this book?
      </Text>
      <Button
        variant="tertiary"
        size="md"
        as={{
          element: "link",
          props: {
            href: `/librarians/apply`,
          },
        }}
      >
        <Icon icon={idIcon} size="sm" />
        Become a Librarian
      </Button>
    </div>
  );
}
